import { useMemo } from "react";
import { Text, Flex, Badge } from "@radix-ui/themes";
import { SkillUsed } from "@/v2/entities/explore/Explore.model";

interface SkillsUsedFormatterProps {
  value?: SkillUsed[];
}

function getSkillName(skill: SkillUsed): string {
  return skill.name;
}

export function SkillsUsedFormatter({ value }: SkillsUsedFormatterProps) {
  const skills = useMemo(() => {
    if (!value || !Array.isArray(value) || value.length === 0) return [];
    return value.map(getSkillName).filter((n) => n && n.trim().length > 0);
  }, [value]);
  if (!skills || skills.length === 0) {
    return (
      <Text color="gray" size="2" as="span">
        None
      </Text>
    );
  }
  return (
    <Flex wrap="wrap" gap="2">
      {skills.map((skill) => (
        <Badge size="1" key={skill} variant="soft" color="gray">
          {skill}
        </Badge>
      ))}
    </Flex>
  );
}
